import { render, staticRenderFns } from "./AllProjects.vue?vue&type=template&id=dbc6534a&"
import script from "./AllProjects.vue?vue&type=script&lang=js&"
export * from "./AllProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports